<div
	class="obg-common-banner-slide-content-wrapper"
	*ngIf="banner"
	[style.backgroundImage]="'url(' + banner.image?.url + ')'"
	[style.maxWidth]="maxWidth ? maxWidth : 'inherit'"
>
	<a class="obg-common-banner-slide-content" [href]="getUrl()">
		<span class="obg-common-banner-slide-title">{{ banner.title }}</span>
		<span class="obg-common-banner-slide-description" *ngIf="banner.description">{{ banner.description }}</span>

		<div
			class="obg-common-banner-slide-terms"
			*ngIf="banner.termsAndConditionsApply && banner.termsAndConditionsDescription"
		>
			<a
				class="obg-common-banner-slide-terms-title"
				*ngIf="showTermsTitle"
				[href]="banner.termsAndConditionsUrl?.url"
				>{{ "terms-and-conditions.title" | translate }}</a
			>
			<a class="obg-common-banner-slide-terms-text" [href]="banner.termsAndConditionsUrl?.url">{{
				banner.termsAndConditionsDescription
			}}</a>
		</div>

		<button class="obg-common-banner-slide-cta" *ngIf="banner.button?.url" [attr.aria-label]="banner.title">
			{{ banner.button?.text }}
		</button>
	</a>
</div>
<div
	class="obg-common-banner-slide-desktop-terms"
	*ngIf="verifiedBanner"
	[innerHtml]="banner.termsAndConditionsDescription"
></div>
